import {Fragment, observer, React} from '@api'
import {ContextMenuItem, GroupByGroupContextMenu, useGroupByGroupHeroCardsStore} from '@modules'


export const HeroSwatchesContextMenu = observer(function HeroSwatchesContextMenu() {
  const {field} = useGroupByGroupHeroCardsStore()

  return <Fragment>
    {/*<ContextMenuItem text={`Custom subgroup ${field?.field}`} />*/}
    <GroupByGroupContextMenu showGroupTitle={false} />

    </Fragment>
  //return <GroupByContext
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/HeroSwatchesContextMenu.tsx